/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectionStringsDto
 */
export interface ConnectionStringsDto {
    /**
     * 
     * @type {string}
     * @memberof ConnectionStringsDto
     */
    server: string;
    /**
     * 
     * @type {number}
     * @memberof ConnectionStringsDto
     */
    port?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionStringsDto
     */
    database: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionStringsDto
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionStringsDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionStringsDto
     */
    additionalParameters?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionStringsDto
     */
    readonly connectionString?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionStringsDto
     */
    $type?: ConnectionStringsDtoTypeEnum;
}


/**
 * @export
 */
export const ConnectionStringsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedInstallDtoConnectionStringsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Install.Dto.ConnectionStringsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ConnectionStringsDtoTypeEnum = typeof ConnectionStringsDtoTypeEnum[keyof typeof ConnectionStringsDtoTypeEnum];


/**
 * Check if a given object implements the ConnectionStringsDto interface.
 */
export function instanceOfConnectionStringsDto(value?: unknown): value is ConnectionStringsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ConnectionStringsDtoTypeEnum)[0];
}

export function ConnectionStringsDtoFromJSON(json: any): ConnectionStringsDto {
    return ConnectionStringsDtoFromJSONTyped(json, false);
}

export function ConnectionStringsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectionStringsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'server': json['server'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'database': json['database'],
        'user': json['user'],
        'password': json['password'],
        'additionalParameters': !exists(json, 'additionalParameters') ? undefined : json['additionalParameters'],
        'connectionString': !exists(json, 'connectionString') ? undefined : json['connectionString'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ConnectionStringsDtoToJSON(value?: ConnectionStringsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'server': value.server,
        'port': value.port,
        'database': value.database,
        'user': value.user,
        'password': value.password,
        'additionalParameters': value.additionalParameters,
        '$type': value.$type,
    });
}

